import { alpha } from '@mui/material';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { MouseEvent } from 'react';

type Tab = {
    label: string;
    count?: number;
};

interface ButtonTabsProps {
    tabs: Tab[];
    value: string;
    setValue: (value: string) => void;
    height?: string;
    testId?: string;
}

export const ButtonTabs = ({
    tabs,
    value,
    setValue,
    height = '40px',
    testId = 'button-tabs-group',
}: ButtonTabsProps) => {
    const onSetValue = (
        _event: MouseEvent<HTMLElement>,
        newAlignment: string | null,
    ) => {
        if (newAlignment !== null) {
            setValue(newAlignment);
        }
    };

    return (
        <ToggleButtonGroup
            value={value}
            exclusive
            onChange={onSetValue}
            data-testid={testId}
        >
            {tabs.map((item) => {
                const displayLabel =
                    item.count != null && item.count > 0
                        ? `${item.label} (${item.count})`
                        : item.label;
                return (
                    <ToggleButton
                        sx={(theme) => ({
                            height,
                            minWidth: '84px',
                            bgcolor: 'rgba(63, 110, 183, 0.1)',
                            color: alpha(theme.palette.text.disabled, 0.6),
                            border: 'none',
                            '&.Mui-selected': {
                                color: 'primary.main',
                                bgcolor: 'white',
                                boxShadow:
                                    '0px 0px 5px 0px rgba(0, 0, 0, 0.15)',
                                borderRadius: '4px',
                            },
                        })}
                        key={item.label}
                        value={item.label}
                    >
                        {displayLabel}
                    </ToggleButton>
                );
            })}
        </ToggleButtonGroup>
    );
};
